import React, { ForwardedRef } from 'react';
import { ShaderMaterialProps } from '@react-three/fiber';
import { useAssetContext } from '../../context/AssetContext';
import { ShaderMaterial } from 'three';

export type CustomShaderMaterialProps = ShaderMaterialProps & {
    fragmentID: string,
    vertexID: string
}

// custom shader is just a shader material but allows using IDs from AssetList to be used for the shader code
const CustomShaderMaterial = React.forwardRef(({
  fragmentID,
  vertexID,
  ...props
}: CustomShaderMaterialProps, ref?: ForwardedRef<ShaderMaterial>) =>
{
  const assets = useAssetContext();

  return <shaderMaterial ref={ref}
    attach='material'
    vertexShader={assets.get(vertexID) as string}
    fragmentShader={assets.get(fragmentID) as string}
    {...props}
  />;
});

CustomShaderMaterial.displayName = 'CustomShaderMaterial';

export default CustomShaderMaterial;